import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { obterCorPorStatus } from '../utils';
import { useTheme } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
import ReactJson from 'react-json-view';
import copy from 'copy-to-clipboard';
import { Box } from '@mui/material';

export default function CadastroItem({ pagamento, statuses }) {
  const [analiseGestor, setAnaliseGestor] = React.useState();
  const [analiseFinanceiro, setAnaliseFinanceiro] = React.useState();
  const [pendencia, setPendencia] = React.useState();
  const [aguardandoPagamento, setAguardandoPagamento] = React.useState();
  const [pago, setPago] = React.useState();
  const theme = useTheme();

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={6}>
          {pagamento && pagamento.erro !== null ? (
            <h3 style={{ color: theme.palette.primary.main }}>Erro</h3>
          ) : null}
          {pagamento && pagamento.erro !== null ? (
            <ReactJson
              src={pagamento && JSON.parse(pagamento.erro)}
              style={{ width: 350, height: 300, overflowY: 'scroll' }}
              enableClipboard={(copyText) => copy(JSON.stringify(copyText))}
            />
          ) : null}
        </Grid>
        <Grid item xs={6}>
          <h3 style={{ color: theme.palette.primary.main }}>Situação</h3>
          <Timeline position="right">
            {statuses &&
              statuses.map((item, index) => {
                return (
                  <TimelineItem key={`item-key-${index}`}>
                    <TimelineSeparator>
                      <TimelineDot
                        style={{ width: 10, height: 10 }}
                        color={index == 0 ? 'grey' : 'primary'}
                      >
                        <CheckIcon
                          fontSize="10"
                          style={{ marginLeft: -2, marginTop: -2 }}
                        />
                      </TimelineDot>
                      <TimelineConnector
                        sx={{
                          bgcolor: index == 0 ? 'grey' : 'primary.main',
                        }}
                      />
                    </TimelineSeparator>
                    <TimelineContent style={{ padding: '0px 16px 16px 16px' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                          style={{
                            borderRadius: 20,
                            width: '60%',
                            height: 25,
                            fontSize: 10,
                          }}
                          variant="contained"
                          color={obterCorPorStatus(item.desc_movto)}
                        >
                          {item.desc_movto}
                        </Button>
                        <span
                          style={{
                            color: '#919191',
                            fontSize: 10,
                            marginLeft: 10,
                          }}
                        >
                          {item.data_movto}
                        </span>
                      </div>
                      <div>
                        <span
                          style={{
                            color: '#919191',
                            fontWeight: 'bold',
                            fontSize: '12px',
                          }}
                        >
                          Observações:
                        </span>
                        <span
                          style={{
                            color: '#919191',
                            marginLeft: 10,
                            fontSize: '12px',
                          }}
                        >
                          {item.obs_movto}
                        </span>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                );
              })}
          </Timeline>
        </Grid>
      </Grid>
    </>
  );
}
